import React, {useRef, useState} from "react";
import emailjs from '@emailjs/browser';
import {ToastContainer, toast} from 'react-toastify';
import Form from 'react-bootstrap/Form';
import 'react-toastify/dist/ReactToastify.css';
import "./ContactMe.css";

function ContactMe({cmCloseModal}) {
    const form = useRef();

    const [enteredName, setEnteredName] = useState(''); //two way binding for form inputs
    const [enteredEmail, setEnteredEmail] = useState('');
    const [enteredSubj, setEnteredSubj] = useState('');
    const [enteredMsg, setEnteredMsg] = useState('');

    const [enteredNameIsValid, setEnteredNameIsValid] = useState(false);
    const [nameAttempted, setNameAttempted] = useState(false); //used to prevent validation warnings from appearing on page load
    const [enteredMsgIsValid, setEnteredMsgIsValid] = useState(false);
    const [msgAttempted, setMsgAttempted] = useState(false); //used to prevent validation warnings from appearing on page load

    const [toastOpenStatus, setToastOpenStatus] = useState(false);

    const nameChangeHandler = (e) => {
        setEnteredName(e.target.value);
    };
    const emailChangeHandler = (e) => {
        setEnteredEmail(e.target.value);
    };
    const subjChangeHandler = (e) => {
        setEnteredSubj(e.target.value);
    };
    const msgChangeHandler = (e) => {
        setEnteredMsg(e.target.value);
    };

    const toggleToast = () => { 
        setToastOpenStatus(!toastOpenStatus);
    };

    const handleToastActivate = () => { 
        if(!toastOpenStatus) {
            toggleToast();
        }
    };

    const nameAttemptInvalid = !enteredNameIsValid && nameAttempted;
    const msgAttemptInvalid = !enteredMsgIsValid && msgAttempted;

    const nameInputClasses = enteredNameIsValid ? 
    'input-validation' : 'invalid input-validation';
    const nameInputColor = nameAttemptInvalid ? 
    'invalid-input' : '';
    const msgInputClasses = enteredMsgIsValid ? 
    'input-validation' : 'invalid input-validation';
    const msgInputColor = msgAttemptInvalid ? 
    'invalid-input' : '';
    const nameCaseInvalid = enteredName.trim() === '' || enteredName.trim().length < 2;
    const msgCaseInvalid = enteredMsg.trim() === '' || enteredMsg.trim().length < 10;

    const sendEmail = (e) => {
        e.preventDefault();
        setNameAttempted(true);
        setMsgAttempted(true);
        if (nameCaseInvalid && !msgCaseInvalid) {
            setEnteredNameIsValid(false);
            setEnteredMsgIsValid(true);
            return;
        } 
        else if (nameCaseInvalid && msgCaseInvalid) {
            setEnteredNameIsValid(false);
            setEnteredMsgIsValid(false);
            return;
        }
        else if (!nameCaseInvalid && msgCaseInvalid) {
            setEnteredNameIsValid(true);
            setEnteredMsgIsValid(false);
            return;
        }
        setEnteredNameIsValid(true);
        setEnteredMsgIsValid(true);
        emailjs.sendForm('service_ab7eq4j', 'template_svjbd3r', form.current, 'eTHvtvzf2LraanPT2')
        .then((result) => {
            console.log(result.text);
            cmCloseModal();
            handleToastActivate();
            toast.success('Message sent!', {position: toast.POSITION.TOP_CENTER});
        }).catch((error) => {
            console.log(error.text);
            toast.error('Error sending message; please try again.', {position: toast.POSITION.TOP_CENTER});
});
        form.current.reset();
};

    return (
        <div className='cm-overlay'>
            <div className='cm-modal'>
                <div className='cm-modal-header'>
                    <h2>Contact Me</h2>
                    <button className='cm-close-modal' onClick={cmCloseModal}>X</button>
                </div>
                <div className='cm-modal-body'>
                    <form ref={form} className="cm-form" onSubmit={sendEmail}>
                        <div className="input-group">
                            <label for="user_name">Name:</label>
                            <div className={nameInputClasses}>
                                <input className={nameInputColor} type="text" id="user_name" name="user_name" placeholder="First and last name" value={enteredName} onChange={nameChangeHandler}></input>
                                {nameAttemptInvalid && <p className="validation-warning">Please enter a name that is 1-100 characters.</p>}
                            </div>
                        </div>
                        <div className="input-group">
                            <label for="user_email">Email Address:</label>
                            <input type="email" id="user_email" name="user_email" placeholder="Email address" value={enteredEmail} onChange={emailChangeHandler}></input>
                        </div>
                        <div className="input-group">
                            <label for="subj">Subject:</label>
                            <input type="text" id="subj" name="subj" placeholder="Message subject line" value={enteredSubj} onChange={subjChangeHandler}></input>
                        </div>
                        <div className="input-group">
                            <label for="msg">Message:</label>
                            <div className={msgInputClasses}>
                                <textarea className={msgInputColor} rows={7} id="msg" name="msg" placeholder="Message body" value={enteredMsg} onChange={msgChangeHandler}></textarea>
                                {msgAttemptInvalid && <p className="validation-warning">Please enter a message of 10-1000 characters.</p>}
                            </div>
                        </div>
                        <button type="submit" className="cm-submit">Submit</button>
                    </form>
                </div>
            </div>
            <ToastContainer/>
        </div>
    );
}

export default ContactMe;